import { render, staticRenderFns } from "./LightHeader.vue?vue&type=template&id=4dbc6a88&"
import script from "./LightHeader.vue?vue&type=script&lang=js&"
export * from "./LightHeader.vue?vue&type=script&lang=js&"
import style0 from "./LightHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports